import { Modal, useModals } from '@renderer/components/Modal'
import { Button } from '@highlight/ui'
import greenHeader from '@assets/backgrounds/green-header.png'
import { ArrowRight } from 'lucide-react'
import { useHasSeenHowYouWorkWelcome } from '../use-has-seen-welcome'
import { useWritingStyleExcerpts } from '../use-writing-style-excerpts'
import { WritingStyleCardStack } from './writing-style-card-stack'

export const HowYouWorkWelcomeModal = () => {
  const { excerpts, isLoading } = useWritingStyleExcerpts()
  const { closeModal } = useModals()
  const [, setHasSeen] = useHasSeenHowYouWorkWelcome()

  const handleClose = () => {
    closeModal('how-you-work-welcome')
    setHasSeen(true)
  }

  return (
    <Modal confirm disableEscape>
      <Modal.Content showClose={false} className="z-[3] overflow-hidden" backdropClassName="z-[2]">
        <div className="flex flex-col">
          <div className="relative">
            <img src={greenHeader} alt="" className="w-full" />
            <div className="absolute inset-x-7 top-1/2 -translate-y-1/2 pr-6">
              <WritingStyleCardStack excerpts={excerpts} isLoading={isLoading} />
            </div>
          </div>
          <div className="flex flex-col gap-4 p-4">
            <Modal.Title className="text-lg font-medium">Introducing How You Work</Modal.Title>
            <Modal.Description
              render={<div />}
              className="text-foreground space-y-2 text-sm font-normal leading-relaxed"
            >
              <p>
                Highlight learns who you work with, what you're working on, and how you write in each app, so it can
                surface what matters and draft in your voice, wherever you're writing.
              </p>
              <p>
                It stays current from your meetings, calendar, screen, and connected apps. You can review or edit it
                anytime in Settings.
              </p>
            </Modal.Description>
            <div className="flex w-full justify-center">
              <Button variant="outline" className="w-[230px]" onClick={handleClose}>
                Explore How You Work <ArrowRight className="size-4" />
              </Button>
            </div>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  )
}
